import { nipige_catalog as API_Nipige_Catalog } from ".";

export const listAttibute = async () => {
  try {
    let result = await API_Nipige_Catalog.get(
      "/api/catalog/read/catalog/attribute"
    );
    return result.data.response;
  } catch (error) {
    return error;
  }
};

export const findByid = async (id) => {
  try {
    let result = await API_Nipige_Catalog.get(
      `/api/catalog/read/catalog/attribute/${id}`
    );
    return result.data.response;
  } catch (error) {
    return error;
  }
};

export const createAttibute = async (obj) => {
  try {
    let result = await API_Nipige_Catalog.post(
      "/api/catalog/write/catalog/attribute",
      { ...obj }
    );
    return result.data;
  } catch (error) {
    return error;
  }
};

export const update = async (id, obj) => {
  try {
    let result = await API_Nipige_Catalog.put(
      `/api/catalog/write/catalog/attribute/${id}`,
      { ...obj }
    );
    return result.data;
  } catch (error) {
    return error;
  }
};

export const deleteAttribute = async (obj) => {
  try {
    let result = await API_Nipige_Catalog.delete(
      `/api/catalog/write/catalog/attribute/${obj}`
    );
    return result.data;
  } catch (error) {
    return error;
  }
};
